import { createPinia } from 'pinia';
import resetStore from '@/commons/services/store/ResetStore';

const pinia = createPinia();
pinia.use(resetStore);

export default pinia;
